module.exports = __webpack_public_path__ + "static/img/8.222c275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/8.png
// module id = MpIG
// module chunks = 35